import restClient from "../restClient";

export const getStatistics = async (type) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { type }
    };
    const response = await restClient.get(`statistics`, config);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
